import React, { useState } from 'react';
import styles from './Sidebar.module.css';

const Sidebar = ({
    title,
    sections = [],
    collapsed = false,
    onToggle,
    defaultCollapsed = false,
    className = '',
    width = '280px',
    mobileHidden = true
}) => {
    const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
    const isCollapsed = collapsed !== undefined ? collapsed : internalCollapsed;

    const handleToggle = () => {
        if (onToggle) {
            onToggle(!isCollapsed);
        } else {
            setInternalCollapsed(!isCollapsed);
        }
    };

    return (
        <aside
            className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''} ${mobileHidden ? styles.mobileHidden : ''} ${className}`}
            style={{ width: isCollapsed ? 'var(--sidebar-collapsed-width)' : width }}
            role="complementary"
            aria-label={title || 'Боковая панель'}
        >
            {/* Заголовок и кнопка сворачивания */}
            {(title || onToggle) && (
                <div className={styles.header}>
                    {title && (
                        <h2 className={styles.title} style={{ display: isCollapsed ? 'none' : 'block' }}>
                            {title}
                        </h2>
                    )}
                    {onToggle && (
                        <button
                            className={styles.toggleButton}
                            onClick={handleToggle}
                            aria-label={isCollapsed ? 'Развернуть панель' : 'Свернуть панель'}
                            aria-expanded={!isCollapsed}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                style={{ transform: isCollapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}
                            >
                                <path
                                    d="M10 12L6 8L10 4"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    )}
                </div>
            )}

            {/* Содержимое панели */}
            <div className={styles.content}>
                {sections.map((section, sectionIndex) => (
                    <section key={sectionIndex} className={styles.section}>
                        {section.title && (
                            <h3 className={styles.sectionTitle} style={{ display: isCollapsed ? 'none' : 'block' }}>
                                {section.title}
                            </h3>
                        )}
                        <div className={styles.sectionContent}>
                            {section.items?.map((item, itemIndex) => (
                                <div
                                    key={itemIndex}
                                    className={`${styles.item} ${item.active ? styles.itemActive : ''} ${item.disabled ? styles.itemDisabled : ''}`}
                                    onClick={() => {
                                        if (!item.disabled && item.onClick) {
                                            item.onClick();
                                        }
                                    }}
                                    style={{ cursor: item.disabled ? 'not-allowed' : 'pointer' }}
                                    role={item.role || 'button'}
                                    aria-disabled={item.disabled}
                                    aria-current={item.active ? 'true' : undefined}
                                >
                                    {item.icon && (
                                        <span className={styles.itemIcon}>{item.icon}</span>
                                    )}
                                    <span className={styles.itemLabel} style={{ display: isCollapsed ? 'none' : 'inline' }}>
                                        {item.label}
                                    </span>
                                    {item.badge && (
                                        <span className={styles.badge} style={{ display: isCollapsed ? 'none' : 'inline' }}>
                                            {item.badge}
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>

            {/* Своранутая панель - иконки */}
            {isCollapsed && (
                <div className={styles.collapsedIcons}>
                    {sections.map((section, sectionIndex) =>
                        section.items?.map((item, itemIndex) => (
                            <div
                                key={`${sectionIndex}-${itemIndex}`}
                                className={`${styles.collapsedIcon} ${item.active ? styles.iconActive : ''}`}
                                onClick={() => {
                                    if (!item.disabled && item.onClick) {
                                        item.onClick();
                                    }
                                }}
                                style={{ cursor: item.disabled ? 'not-allowed' : 'pointer' }}
                                title={item.label}
                                aria-label={item.label}
                            >
                                {item.icon}
                            </div>
                        ))
                    )}
                </div>
            )}
        </aside>
    );
};

export default Sidebar;
